/* ==========================================================================
   Bundle Builder — Page JS (bundle-builder-page.js)
   Products loaded via /products/{handle}.js to bypass all_products[] limit.
   v2 - 2026-03-24
   ========================================================================== */

   (function () {
    'use strict';
  
    var DATA = window.BB_PAGE_DATA;
  
    if (!DATA) {
      return;
    }
  
    var maxSlots = DATA.maxSlots || 4;
    var tiers = DATA.tiers || [];
    var handles = DATA.handles || [];
    var moneyFormat = DATA.moneyFormat || '${{amount}}';
  
    /* ---- State ---- */
    var selectedItems = []; // { variantId, productId, handle, title, price, image }
    var loadedProducts = {}; // keyed by handle
  
    /* ---- DOM refs ---- */
    var page = document.getElementById('BundleBuilderPage');
    var grid = document.getElementById('bbProductGrid');
    var slotsContainer = document.getElementById('bbSlots');
    var addToCartBtn = document.getElementById('bbAddToCart');
    var mobileAddToCartBtn = document.getElementById('bbMobileAddToCart');
    var mobileOneTimeBtn = document.getElementById('bbMobileOneTimePurchase');
    var mobileFill = document.querySelector('[data-mobile-fill]');
    var mobileCounter = document.querySelector('[data-mobile-counter]');
    var mobilePrice = document.querySelector('[data-mobile-price]');
    var mobileOneTimePriceEl = document.querySelector('[data-mobile-one-time-price]');
    var bundlePriceEl = document.querySelector('[data-bundle-price]');
    var oneTimePriceEl = document.querySelector('[data-one-time-price]');
    var oneTimePurchaseBtn = document.getElementById('bbOneTimePurchaseBtn');
    var statusEl = document.getElementById('bbStatus');
  
    if (!page || !grid) return;
  
    /* ===========================================================
       H1 NORMALIZATION
       Convert any h1 that is NOT the bundle banner title to h2,
       so the page has exactly one h1 for SEO correctness.
       This mainly targets h1s injected by Shogun product descriptions.
       =========================================================== */
    (function normalizeH1s() {
      var allH1s = document.querySelectorAll('h1:not(.bundle-banner__title)');
      for (var i = 0; i < allH1s.length; i++) {
        var h1 = allH1s[i];
        var h2 = document.createElement('h2');
        // Copy all attributes (class, id, style, data-*, etc.)
        for (var a = 0; a < h1.attributes.length; a++) {
          h2.setAttribute(h1.attributes[a].name, h1.attributes[a].value);
        }
        h2.innerHTML = h1.innerHTML;
        h1.parentNode.replaceChild(h2, h1);
      }
    })();
  
    /* ===========================================================
       FORMAT MONEY
       =========================================================== */
    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var noDecimals = Math.round(cents / 100).toString();
      return (moneyFormat || '${{amount}}')
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace('{{amount_no_decimals}}', noDecimals)
        .replace('{{amount}}', amount);
    }
  
    /* ===========================================================
       GET CURRENT TIER
       =========================================================== */
    function getCurrentTier(qty) {
      var active = null;
      for (var i = 0; i < tiers.length; i++) {
        if (qty >= tiers[i].qty) active = tiers[i];
      }
      return active;
    }
  
    var SUBSCRIBE_DISCOUNT_PCT_FALLBACK = 10;

    function stackedDiscountPct(tierPct, extraPct) {
      var tier = Number(tierPct) || 0;
      var extra = Number(extraPct) || 0;
      if (!tier) return extra;
      if (!extra) return tier;
      return Math.round(100 - ((100 - tier) * (100 - extra) / 100));
    }

    function getBundlePct(tier) {
      if (!tier) return 0;
      var pct = Number(tier.pct) || 0;
      if (pct === 24) return 15;
      if (pct === 28) return 20;
      if (pct === 33) return 25;
      return pct;
    }

    function getStackedPct(tier) {
      if (!tier) return 0;
      if (tier.displayPct != null) return Number(tier.displayPct) || 0;
      var pct = Number(tier.pct) || 0;
      if (pct === 24 || pct === 28 || pct === 33) return pct;
      return stackedDiscountPct(getBundlePct(tier), SUBSCRIBE_DISCOUNT_PCT_FALLBACK);
    }

    function getDisplayPct(tier) {
      return getStackedPct(tier);
    }

    /* Bundle % once on the group subtotal (one round). Per-line floor is
       how a Function can round, but Shopify's cart total for this stack
       is the group round: $154.76 × 0.75 = $116.07. */

    function isSubscribeChecked() {
      var cb = document.getElementById('bbSubscribeCheckbox');
      return cb && cb.checked;
    }

    function getItemSubscribePrice(item) {
      var adj = DATA.sellingPlanAdjustments && DATA.sellingPlanAdjustments[item.handle];
      if (!adj) return Math.round(item.price * (100 - SUBSCRIBE_DISCOUNT_PCT_FALLBACK) / 100);
      if (adj.valueType === 'percentage') {
        return Math.round(item.price * (100 - adj.value) / 100);
      } else if (adj.valueType === 'fixed_amount') {
        return Math.max(0, item.price - adj.value);
      }
      return adj.value;
    }

    function applyGroupPercentOff(cents, pct) {
      var amount = Number(cents) || 0;
      var p = Number(pct) || 0;
      if (p <= 0 || amount <= 0) return amount;
      return Math.round(amount * (100 - p) / 100);
    }

    function computeItemsTotal(subscribe) {
      var bundlePct = getBundlePct(getCurrentTier(selectedItems.length));
      var subtotal = 0;
      for (var i = 0; i < selectedItems.length; i++) {
        var item = selectedItems[i];
        subtotal += (subscribe && item.sellingPlanId) ? getItemSubscribePrice(item) : item.price;
      }
      return applyGroupPercentOff(subtotal, bundlePct);
    }

    function computeOneTimePrice() {
      return computeItemsTotal(false);
    }

    function computePrice() {
      return computeItemsTotal(isSubscribeChecked());
    }
  
    /* ===========================================================
       UPDATE UI
       =========================================================== */
    function updateUI() {
      var count = selectedItems.length;
  
      // --- SINGLE UNIFIED STATUS BAR ---
      if (statusEl) {
        var headingEl = document.getElementById('bbStatusHeading');
        var fillEl    = document.getElementById('bbStatusFill');
        var countEl   = document.getElementById('bbStatusCount');
        var barEl     = document.getElementById('bbStatusBar');
        var innerEl   = document.getElementById('bbStatusInner');
  
        var fillPct  = count === 0 ? 0 : count === 1 ? 30 : Math.min((count / maxSlots) * 100, 100);
        var complete = count >= maxSlots;
  
        // Find the next tier the user is working towards
        var activeTier = tiers[tiers.length - 1]; // default: last
        for (var t = 0; t < tiers.length; t++) {
          if (count < tiers[t].qty) { activeTier = tiers[t]; break; }
        }
        var lastReachedTier = null;
        for (var t = 0; t < tiers.length; t++) {
          if (count >= tiers[t].qty) lastReachedTier = tiers[t];
        }
  
        // Fill width
        if (fillEl) fillEl.style.width = fillPct + '%';
  
        // Count label
        if (countEl) countEl.textContent = count + ' of ' + maxSlots;
  
        // Bar color: green when max slots reached, blue otherwise
        if (barEl) {
          barEl.classList.toggle('is-complete', complete);
          barEl.classList.toggle('is-empty', count === 0);
        }

        // Position inner centered on the fill. Empty state is CSS-centered
        // on the full track (JS left/width is unreliable while the bar is
        // hidden or still laying out, e.g. quiz results).
        if (innerEl && barEl) {
          if (count === 0) {
            innerEl.style.left = '';
            innerEl.style.width = '';
          } else {
            var barW  = barEl.offsetWidth;
            var fillW = barW * (fillPct / 100);
            var innerW = innerEl.offsetWidth;
            innerEl.style.left  = ((fillW / 2) - (innerW / 2)) + 'px';
            innerEl.style.width = innerW + 'px';
          }
        }
  
        // Heading text
        if (headingEl) {
          if (complete) {
            headingEl.textContent = '\uD83C\uDF89 Congrats! You\'re Saving more than ' + getDisplayPct(lastReachedTier || activeTier) + '%';
            headingEl.classList.add('is-complete');
          } else {
            var needed = activeTier.qty - count;
            headingEl.textContent = (needed === 1 ? 'Add 1 more' : 'Add ' + needed) + ' to Save ' + getDisplayPct(activeTier) + '% and more!';
            headingEl.classList.remove('is-complete');
          }
        }
      }
  
      // Slots
      var slots = slotsContainer ? slotsContainer.querySelectorAll('.bb-aside__slot') : [];
      for (var i = 0; i < slots.length; i++) {
        var slot = slots[i];
        var thumb = slot.querySelector('.bb-aside__slot-thumb');
        var text = slot.querySelector('.bb-aside__slot-text');
        var badgesWrap = slot.querySelector('.bb-aside__slot-badges');
        var removeBtn = slot.querySelector('[data-action="remove-slot"]');
  
        if (i < count) {
          var item = selectedItems[i];
          slot.classList.add('is-filled');
          if (thumb) thumb.style.backgroundImage = 'url(' + item.image + ')';
          if (text) text.textContent = item.title;
          if (removeBtn) removeBtn.classList.remove('cart--hidden');
  
          // Build badges HTML for the slot (no price, no stars)
          if (badgesWrap) {
            var meta = (BB_PAGE_DATA.productMeta && BB_PAGE_DATA.productMeta[item.handle]) || {};
            var _slotBadges = '';
  
            // Info badges
            if (meta.infoBadges && meta.infoBadges.length) {
              var _ib = meta.infoBadges.filter(function (b) { return b && b.trim() !== '' && !/serving|fat.?loss/i.test(b); });
              if (_ib.length) {
                _slotBadges += '<div class="grid-product__info-badges">'
                  + _ib.map(function (b) { return '<span class="grid-product__info-badge">' + escapeHTML(b.trim()) + '</span>'; }).join('')
                  + '</div>';
              }
            }
  
            // Info highlights
            if (meta.infoHighlights && meta.infoHighlights.length) {
              var _badgeSet = (meta.infoBadges || []).map(function (b) { return b.trim().toUpperCase(); });
              var _hl = meta.infoHighlights.filter(function (h) { return h && h.trim() !== '' && _badgeSet.indexOf(h.trim().toUpperCase()) === -1; });
              if (_hl.length) {
                _slotBadges += '<div class="grid-product__info-highlights">'
                  + _hl.map(function (h) { return '<span class="grid-product__info-highlight">' + escapeHTML(h.trim()) + '</span>'; }).join('')
                  + '</div>';
              }
            }
  
            // Preset badges
            if (meta.badgeMostPopular || meta.badgeBestSeller || meta.badgeNewIn || meta.badgeBestValue) {
              _slotBadges += '<div class="grid-product__preset-badges">';
              if (meta.badgeMostPopular) _slotBadges += '<span class="grid-product__preset-badge grid-product__preset-badge--most-popular">MOST POPULAR CHOICE</span>';
              if (meta.badgeBestSeller)  _slotBadges += '<span class="grid-product__preset-badge grid-product__preset-badge--best-seller">BEST SELLER</span>';
              if (meta.badgeNewIn)       _slotBadges += '<span class="grid-product__preset-badge grid-product__preset-badge--new-in">NEW IN</span>';
              if (meta.badgeBestValue)   _slotBadges += '<span class="grid-product__preset-badge grid-product__preset-badge--best-value">BEST VALUE</span>';
              _slotBadges += '</div>';
            }
  
            badgesWrap.innerHTML = _slotBadges;
          }
        } else {
          slot.classList.remove('is-filled');
          if (thumb) thumb.style.backgroundImage = '';
          if (text) text.textContent = 'Select a product';
          if (badgesWrap) badgesWrap.innerHTML = '';
          if (removeBtn) removeBtn.classList.add('cart--hidden');
        }
      }
  
      // Price
      var total = computePrice();
      var priceStr = formatMoney(total);
      if (bundlePriceEl) bundlePriceEl.textContent = priceStr;
      if (mobilePrice) mobilePrice.textContent = priceStr;
      var oneTimePriceStr = formatMoney(computeOneTimePrice());
      if (oneTimePriceEl) oneTimePriceEl.textContent = oneTimePriceStr;
      if (mobileOneTimePriceEl) mobileOneTimePriceEl.textContent = oneTimePriceStr;
  
      if (mobileCounter) mobileCounter.textContent = count + '/' + maxSlots;
      if (mobileFill) mobileFill.style.width = (count === 0 ? 0 : count === 1 ? 30 : Math.min((count / maxSlots) * 100, 100)) + '%';
  
      var minTierQty = tiers.length > 0 ? tiers[0].qty : 2;
      var canAdd = count >= minTierQty;
      if (addToCartBtn) addToCartBtn.disabled = !canAdd;
      if (mobileAddToCartBtn) mobileAddToCartBtn.disabled = !canAdd;
      if (mobileOneTimeBtn) mobileOneTimeBtn.disabled = !canAdd;
      if (oneTimePurchaseBtn) oneTimePurchaseBtn.disabled = !canAdd;
  
      // Update CTA label to reflect subscribe state
      var ctaLabel = addToCartBtn ? addToCartBtn.querySelector('.bb-aside__cta-label') : null;
      if (ctaLabel && !addToCartBtn.disabled) {
        ctaLabel.textContent = isSubscribeChecked() ? 'ADD BUNDLE ' : 'ADD BUNDLE';
      }
    }
  
    /* ===========================================================
       HELPERS
       =========================================================== */
    function escapeHTML(str) {
      return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    }
  
    function escapeAttr(str) {
      return String(str).replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }
  
    /* ===========================================================
       BUILD CARD HTML from product JSON
       =========================================================== */
    function buildCardHTML(product) {
      var handle = product.handle;
      var img = product.featured_image || (product.images && product.images[0] && product.images[0].src) || '';
      var imgSrc = img ? (img.split('?')[0] + '?width=500') : '';
      var price = product.price_min || (product.variants[0] && product.variants[0].price) || 0;
      var compareAt = product.compare_at_price_min || product.compare_at_price || 0;
      var availableVariants = product.variants.filter(function (v) { return v.available; });
  
      var meta = (BB_PAGE_DATA.productMeta && BB_PAGE_DATA.productMeta[handle]) || {};
      var displayName = (BB_PAGE_DATA.customNames && BB_PAGE_DATA.customNames[handle]) || product.title;
  
      var addBtnHTML = '';
      if (availableVariants.length === 0) {
        addBtnHTML = '<span class="bb-card__sold-out">Sold out</span>';
      } else {
        // Determine if the product has a pack/size option (non-flavour option with multiple values).
        // If it does → always add the single item directly (no dropdown).
        // If it only has flavour variants → show a flavour dropdown on the card.
        var hasPackOption = false;
        var opts = product.options || [];
        for (var _oi = 0; _oi < opts.length; _oi++) {
          var _oName = (typeof opts[_oi] === 'object' && opts[_oi] !== null) ? (opts[_oi].name || '') : String(opts[_oi]);
          if (!isFlavourOption(_oName)) {
            // Check if this non-flavour option actually has more than one unique value
            var _seen = {};
            for (var _vi = 0; _vi < product.variants.length; _vi++) {
              _seen[product.variants[_vi]['option' + (_oi + 1)]] = true;
            }
            if (Object.keys(_seen).length > 1) { hasPackOption = true; break; }
          }
        }
  
        if (hasPackOption) {
          // Has pack/size variants → add single item directly, no dropdown
          var singleVariant = pickSingleItemVariant(product, flavourOptionIndex(product), null);
          var vid = singleVariant ? singleVariant.id : availableVariants[0].id;
          addBtnHTML = '<button class="bb-card__add-btn" type="button" data-action="add-direct" data-variant-id="' + vid + '" aria-label="Add to bundle">'
            + '<svg class="bb-card__add-icon" viewBox="0 0 16 16" fill="none"><path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/></svg>'
            + '<span class="bb-card__add-label">Add to bundle</span></button>';
        } else if (availableVariants.length === 1 || (product.variants.length === 1)) {
          // Single variant only → add directly
          var vid = availableVariants[0].id;
          addBtnHTML = '<button class="bb-card__add-btn" type="button" data-action="add-direct" data-variant-id="' + vid + '" aria-label="Add to bundle">'
            + '<svg class="bb-card__add-icon" viewBox="0 0 16 16" fill="none"><path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/></svg>'
            + '<span class="bb-card__add-label">Add to bundle</span></button>';
        } else {
          // Only flavour variants → show flavour dropdown on card
          var optionBtns = availableVariants.map(function (v) {
            return '<button class="bb-card__variant-btn" type="button" data-action="add-direct" data-variant-id="' + v.id + '">' + escapeHTML(v.title) + '</button>';
          }).join('');
          addBtnHTML = '<div class="bb-card__variant-panel" data-variant-panel>'
            + '<div class="bb-card__variant-trigger" data-variant-trigger>'
            + '<svg class="bb-card__add-icon" viewBox="0 0 16 16" fill="none"><path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/></svg>'
            + '</div>'
            + '<div class="bb-card__variant-options" data-variant-options>' + optionBtns + '</div>'
            + '</div>';
        }
      }
  
      // ---- Loox stars ----
      var looxHtml = '';
      if (meta.looxRating && meta.looxRaters) {
        looxHtml = '<div class="grid-product__loox">'
          + '<div class="loox-rating loox-stars" data-id="' + meta.looxId + '" data-rating="' + meta.looxRating + '" data-raters="' + meta.looxRaters + '"></div>'
          + '</div>';
      }
  
      // ---- Info badges (from custom.info_badges metafield) — skip servings & fat-loss badges ----
      var infoBadgesHtml = '';
      if (meta.infoBadges && meta.infoBadges.length) {
        var badgeItems = meta.infoBadges.filter(function (b) {
          return b && b.trim() !== '' && !/serving|fat.?loss/i.test(b);
        });
        if (badgeItems.length) {
          infoBadgesHtml = '<div class="grid-product__info-badges">'
            + badgeItems.map(function (b) { return '<span class="grid-product__info-badge">' + escapeHTML(b.trim()) + '</span>'; }).join('')
            + '</div>';
        }
      }
  
      // ---- Info highlights (from custom.info_highlights metafield) ----
      var infoHighlightsHtml = '';
      if (meta.infoHighlights && meta.infoHighlights.length) {
        var badgeSet = (meta.infoBadges || []).map(function (b) { return b.trim().toUpperCase(); });
        var hlItems = meta.infoHighlights.filter(function (h) {
          return h && h.trim() !== '' && badgeSet.indexOf(h.trim().toUpperCase()) === -1;
        });
        if (hlItems.length) {
          infoHighlightsHtml = '<div class="grid-product__info-highlights">'
            + hlItems.map(function (h) { return '<span class="grid-product__info-highlight">' + escapeHTML(h.trim()) + '</span>'; }).join('')
            + '</div>';
        }
      }
  
      // ---- Preset badges (from individual boolean metafields, exact same as PLP) ----
      var presetBadgesHtml = '';
      if (meta.badgeMostPopular || meta.badgeBestSeller || meta.badgeNewIn || meta.badgeBestValue) {
        presetBadgesHtml = '<div class="grid-product__preset-badges">';
        if (meta.badgeMostPopular) presetBadgesHtml += '<span class="grid-product__preset-badge grid-product__preset-badge--most-popular">MOST POPULAR CHOICE</span>';
        if (meta.badgeBestSeller)  presetBadgesHtml += '<span class="grid-product__preset-badge grid-product__preset-badge--best-seller">BEST SELLER</span>';
        if (meta.badgeNewIn)       presetBadgesHtml += '<span class="grid-product__preset-badge grid-product__preset-badge--new-in">NEW IN</span>';
        if (meta.badgeBestValue)   presetBadgesHtml += '<span class="grid-product__preset-badge grid-product__preset-badge--best-value">BEST VALUE</span>';
        presetBadgesHtml += '</div>';
      }
  
      // Preset badges first, then celeste (info) badges last
      var badgeRowHtml = (presetBadgesHtml || infoHighlightsHtml || infoBadgesHtml)
        ? '<div class="grid-product__badge-row">' + presetBadgesHtml + infoHighlightsHtml + infoBadgesHtml + '</div>'
        : '';
  
      // ---- Price ----
      var priceHtml = '<div class="grid-product__price">';
      if (compareAt && compareAt > price) {
        priceHtml += '<span class="grid-product__price--original">' + formatMoney(compareAt) + '</span>'
          + '<span class="sale-price">' + formatMoney(price) + '</span>';
      } else {
        priceHtml += '<span>' + formatMoney(price) + '</span>';
      }
      priceHtml += '</div>';
  
      var metaHtml = '<div class="grid-product__meta">'
        + looxHtml
        + '<div class="grid-product__title">' + escapeHTML(displayName) + '</div>'
        + badgeRowHtml
        + priceHtml
        + '</div>';
  
      return '<div class="bb-card__img-wrap">'
        + (imgSrc ? '<img class="bb-card__img" src="' + imgSrc + '" alt="' + escapeAttr(product.title) + '" loading="lazy" width="500" height="500">' : '')
        + addBtnHTML
        + '</div>'
        + '<div class="bb-card__info">'
        + metaHtml
        + '<button class="bb-card__read-more" type="button" data-action="read-more" data-href="/products/' + handle + '">Learn more</button>'
        + '</div>';
    }
  
    /* ===========================================================
       LOAD PRODUCTS via /products/{handle}.js
       =========================================================== */
    function loadProduct(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('Not found: ' + handle);
          return res.json();
        })
        .then(function (product) {
          loadedProducts[handle] = product;
  
          var card = grid.querySelector('.bb-card[data-product-handle="' + handle + '"]');
          if (!card) return;
  
          card.classList.remove('bb-card--loading');
          card.setAttribute('data-product-id', product.id);
          var _customTitle = (BB_PAGE_DATA.customNames && BB_PAGE_DATA.customNames[handle]) || product.title;
          card.setAttribute('data-product-title', escapeAttr(_customTitle));
          card.setAttribute('data-product-price', product.price_min || product.variants[0].price);
          card.setAttribute('data-product-image', product.featured_image || (product.images[0] && product.images[0].src) || '');
          card.setAttribute('data-variants-json', JSON.stringify(product.variants));
          card.innerHTML = buildCardHTML(product);
        })
        .catch(function (err) {
          var card = grid.querySelector('.bb-card[data-product-handle="' + handle + '"]');
          if (card) card.style.display = 'none';
        });
    }
  
    /* ===========================================================
       ADD ITEM
       =========================================================== */
    function addToBundle(variantId, card) {
      if (selectedItems.length >= maxSlots) return;
  
      var title = card.getAttribute('data-product-title') || '';
      var price = parseInt(card.getAttribute('data-product-price'), 10) || 0;
      var image = card.getAttribute('data-product-image') || '';
      var handle = card.getAttribute('data-product-handle') || '';
  
      try {
        var variants = JSON.parse(card.getAttribute('data-variants-json') || '[]');
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) {
            price = variants[i].price;
            if (variants[i].featured_image && variants[i].featured_image.src) image = variants[i].featured_image.src;
            break;
          }
        }
      } catch (e) { /* ignore */ }

      /* Resolve the selling plan for this product from the server-rendered map.
         /products/{handle}.js does NOT include selling_plan_groups, so we read
         the first selling plan ID from BB_PAGE_DATA.sellingPlans which is built
         from Liquid SKIO selling plan groups (first Delivery plan per handle). */
      var sellingPlanId = null;
      if (DATA.sellingPlans && DATA.sellingPlans[handle]) {
        sellingPlanId = DATA.sellingPlans[handle];
      }

      selectedItems.push({
        variantId: variantId,
        handle: handle,
        title: title,
        price: price,
        image: image,
        sellingPlanId: sellingPlanId
      });
      card.setAttribute('data-variant-id-selected', variantId);
      card.classList.add('is-selected');
  
      var panel = card.querySelector('[data-variant-panel]');
      if (panel) panel.classList.remove('is-open');
  
      updateUI();
    }
  
    /* ===========================================================
       REMOVE ITEM
       =========================================================== */
    function removeFromBundle(filledIndex) {
      if (filledIndex < 0 || filledIndex >= selectedItems.length) return;
      var removed = selectedItems.splice(filledIndex, 1)[0];
      if (removed) {
        var card = grid.querySelector('.bb-card[data-variant-id-selected="' + removed.variantId + '"]');
        if (card) {
          card.removeAttribute('data-variant-id-selected');
          card.classList.remove('is-selected');
        }
      }
      updateUI();
    }
  
    /* ===========================================================
       ADD TO CART
       Detects whether ANY cart drawer is present in the DOM.
       Both the native theme drawer (snippets/cart-drawer.liquid) and
       the upnova-like drawer (snippets/cart-drawer-upnova-like.liquid)
       use the same data-drawer="drawer-cart" attribute, so one check
       covers both scenarios.
  
       - Drawer found  → POST /cart/add.js, dispatch ajaxProduct:added
                         so Motion opens the drawer & rebuilds items.
       - No drawer     → POST /cart/add.js, then redirect to /cart.
       =========================================================== */
  
    function cartDrawerIsActive() {
      // Motion theme: cart drawer has id="CartDrawer" and only exists in
      // the DOM when settings.cart_type == 'drawer'
      return !!document.querySelector('#CartDrawer');
    }
  
    function openCartDrawer() {
      // Motion theme uses theme.Drawers — trigger via the cart icon click
      // which fires drawerOpen + drawerOpen.CartDrawer events internally.
      var toggle = document.querySelector('.js-drawer-open-cart');
      if (toggle) {
        toggle.click();
        return;
      }
      // Fallback: dispatch Motion's drawerOpen.CartDrawer event directly
      document.dispatchEvent(new CustomEvent('drawerOpen.CartDrawer'));
    }

    function refreshAndOpenCartDrawer(addedVariantId) {
      function afterDrawerPaint() {
        if (typeof window.bbRehydrateBundleBuilderCart === 'function') {
          window.bbRehydrateBundleBuilderCart();
        }
      }

      // Primary path used across this codebase when available.
      if (typeof window.refreshCart === 'function') {
        var rc = window.refreshCart({ openDrawer: true });
        if (rc && typeof rc.then === 'function') {
          return rc.then(afterDrawerPaint);
        }
        afterDrawerPaint();
        return Promise.resolve();
      }

      // Fallback for environments where refreshCart isn't defined:
      // render the same sections cart-drawer.js expects, then open.
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
        openCartDrawer();
        afterDrawerPaint();
        return Promise.resolve();
      }

      return fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          cartDrawer.renderContents({
            id: addedVariantId || null,
            sections: sections || {}
          });
        })
        .then(afterDrawerPaint)
        .catch(function () {
          // Last-resort fallback: try opening whatever drawer implementation exists.
          openCartDrawer();
          afterDrawerPaint();
        });
    }
  
    /* ===========================================================
       BUNDLE ID — unique per "add bundle" action so all items
       in this bundle can be identified as a group in the cart.
       Used by Shopify Discount Functions to target only bundle
       items (via the _bundle_item / _bundle_id line properties).
       =========================================================== */
    function generateBundleId() {
      return 'bb-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
    }

    function cartHasBuilderBundle(cart) {
      if (!cart || !cart.items || !cart.items.length) return false;
      return cart.items.some(function (i) {
        if (!i.properties) return false;
        return i.properties['_bundle_item'] === 'true' || i.properties['_bundle_item'] === true;
      });
    }
  
    function addBundleToCart(opts) {
      var options = opts || {};
      var forceOneTime = !!options.forceOneTime;
      var sourceButton = options.sourceButton || null;
      var minTierQty = tiers.length > 0 ? tiers[0].qty : 2;
      if (selectedItems.length < minTierQty) return;
  
      // Determine active tier & discount %
      var activeTier = getCurrentTier(selectedItems.length);
      var discountPct = activeTier ? activeTier.pct : 0;
  
      // Is Subscribe & Save active?
      var wantsSubscription = forceOneTime ? false : isSubscribeChecked();
  
      // Generate a shared bundle ID for this group of items.
      // The Shopify Discount Function reads _bundle_item and
      // _bundle_id to group items and apply the correct tier %
      // only to these line items, ignoring everything else in
      // the cart.
      var bundleId = generateBundleId();
  
      // Build cart items.
      // Keep one entry per selected item so line item properties are always
      // attached to every add operation (even for duplicate variants).
      var itemsToAdd = selectedItems.map(function (item) {
        var entry = {
          id: String(item.variantId),
          quantity: 1,
          properties: {
            '_bundle_item': 'true',
            '_bundle_id': bundleId
          }
        };
        // Store selling plan ID so the cart drawer toggle can enable subscription later
        if (item.sellingPlanId) {
          entry.properties['_selling_plan_id'] = String(item.sellingPlanId);
        }
        // When subscribe is checked and the product has a selling plan,
        // attach it so Shopify creates a subscription line item.
        if (wantsSubscription && item.sellingPlanId) {
          entry.selling_plan = item.sellingPlanId;
        }
        return entry;
      });
  
      var ctaLabel = addToCartBtn ? addToCartBtn.querySelector('.bb-aside__cta-label') : null;
      var defaultLabel = isSubscribeChecked() ? 'ADD BUNDLE' : 'ADD BUNDLE';

      function restoreCta(label) {
        if (ctaLabel) { ctaLabel.textContent = label || defaultLabel; }
        if (addToCartBtn) { addToCartBtn.disabled = false; }
        if (mobileAddToCartBtn) { mobileAddToCartBtn.disabled = false; }
        if (mobileOneTimeBtn) { mobileOneTimeBtn.disabled = false; }
        if (oneTimePurchaseBtn) { oneTimePurchaseBtn.disabled = false; }

        if (sourceButton === mobileAddToCartBtn && mobileAddToCartBtn) {
          mobileAddToCartBtn.innerHTML = 'ADD BUNDLE · <span data-mobile-price>' + formatMoney(computePrice()) + '</span>';
          mobilePrice = document.querySelector('[data-mobile-price]');
        }
        if (sourceButton === mobileOneTimeBtn && mobileOneTimeBtn) {
          mobileOneTimeBtn.innerHTML = 'Buy once · <span data-mobile-one-time-price>' + formatMoney(computeOneTimePrice()) + '</span>';
          mobileOneTimePriceEl = document.querySelector('[data-mobile-one-time-price]');
        }
        if (sourceButton === oneTimePurchaseBtn && oneTimePurchaseBtn) {
          oneTimePurchaseBtn.innerHTML = 'Buy It Once for <span data-one-time-price>' + formatMoney(computeOneTimePrice()) + '</span>';
          oneTimePriceEl = document.querySelector('[data-one-time-price]');
        }
      }

      if (DATA.existingBundleBehavior === 'block') {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cartHasBuilderBundle(cart)) {
              restoreCta();
              if (ctaLabel) {
                ctaLabel.textContent = 'Remove your bundle from the cart to build a new one';
              }
              return;
            }
            runBundleAddToCart();
          })
          .catch(function () {
            runBundleAddToCart();
          });
        return;
      }

      runBundleAddToCart();

      function runBundleAddToCart() {
      if (addToCartBtn) { addToCartBtn.disabled = true; }
      if (mobileAddToCartBtn) { mobileAddToCartBtn.disabled = true; }
      if (mobileOneTimeBtn) { mobileOneTimeBtn.disabled = true; }
      if (oneTimePurchaseBtn) { oneTimePurchaseBtn.disabled = true; }

      if (sourceButton === oneTimePurchaseBtn && oneTimePurchaseBtn) {
        oneTimePurchaseBtn.textContent = 'Adding\u2026';
      } else if (sourceButton === mobileOneTimeBtn && mobileOneTimeBtn) {
        mobileOneTimeBtn.textContent = 'Adding\u2026';
      } else if (sourceButton === mobileAddToCartBtn && mobileAddToCartBtn) {
        mobileAddToCartBtn.textContent = 'Adding\u2026';
      } else if (ctaLabel) {
        ctaLabel.textContent = 'Adding\u2026';
      }
  
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: itemsToAdd })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed: ' + res.status);
        // No need to fetch /cart.js here — the MutationObserver in
        // bundle-builder-cart.js will call fetchCartAndSync() after
        // Motion finishes buildCart(), which fetches it once.
        return res.json();
      })
      .then(function () {
        restoreCta(defaultLabel);

        if (cartDrawerIsActive()) {
          var firstAddedId = itemsToAdd[0] && itemsToAdd[0].id;
          // Cloak [data-products] before Motion re-renders it so bundle items
          // never flash as individual rows. bundle-builder-cart.js removes the
          // cloak once groupBundleItems has hidden the rows.
          var productsEl = document.querySelector('[data-products]');
          if (productsEl) {
            productsEl.classList.add('bb-cloaked');
            // Safety net: always uncloak after 3s in case something goes wrong
            setTimeout(function() { productsEl.classList.remove('bb-cloaked'); }, 3000);
          }
  
          return refreshAndOpenCartDrawer(firstAddedId);
        } else {
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          window.location.href = root + 'cart';
        }
      })
      .catch(function (err) {
        if (sourceButton === oneTimePurchaseBtn && oneTimePurchaseBtn) {
          oneTimePurchaseBtn.textContent = 'Error \u2014 try again';
        } else if (sourceButton === mobileOneTimeBtn && mobileOneTimeBtn) {
          mobileOneTimeBtn.textContent = 'Error \u2014 try again';
        } else if (sourceButton === mobileAddToCartBtn && mobileAddToCartBtn) {
          mobileAddToCartBtn.textContent = 'Error \u2014 try again';
        } else if (ctaLabel) {
          ctaLabel.textContent = 'Error \u2014 try again';
        }
        if (addToCartBtn) { addToCartBtn.disabled = false; }
        if (mobileAddToCartBtn) { mobileAddToCartBtn.disabled = false; }
        if (mobileOneTimeBtn) { mobileOneTimeBtn.disabled = false; }
        if (oneTimePurchaseBtn) { oneTimePurchaseBtn.disabled = false; }
      });
      }
    }
  
    /* ===========================================================
       PRODUCT MODAL — dynamic "Learn More" overlay
       Fetches full product data from /products/{handle}.js,
       populates image gallery, variants, description, price.
       =========================================================== */
    var modal = document.getElementById('bbProductModal');
    var modalTitle = document.getElementById('bbModalTitle');
    var modalPrice = document.getElementById('bbModalPrice');
    var modalComparePrice = document.getElementById('bbModalComparePrice');
    var modalDiscountTag = document.getElementById('bbModalDiscountTag');
    var modalVariants = document.getElementById('bbModalVariants');
    var modalMainCarousel = document.getElementById('bbModalMainCarousel');
    var modalMainTrack = document.getElementById('bbModalMainTrack');
    var modalThumbTrack = document.getElementById('bbModalThumbTrack');
    var modalDescription = document.getElementById('bbModalDescription');
    var modalAddBtn = document.getElementById('bbModalAddBtn');
  
    var _modalProduct = null;    // current product JSON
    var _modalVariantId = null;  // currently selected variant ID
    var _modalHandle = null;
  
    function openModal(handle) {
      if (!modal) return;
      _modalHandle = handle;
  
      var product = loadedProducts[handle];
      if (!product) return;
  
      _modalProduct = product;
  
      // ---- Title ----
      var _modalDisplayName = (BB_PAGE_DATA.customNames && BB_PAGE_DATA.customNames[handle]) || product.title;
      if (modalTitle) modalTitle.textContent = _modalDisplayName;
  
      // ---- Pick first available variant — always the single item (lowest price) ----
      // If the product has a flavour option, pick the single-item variant of the
      // first available flavour value. Otherwise just pick the cheapest available.
      var flavIdx = flavourOptionIndex(product);
      var defaultFlavVal = null;
      if (flavIdx >= 0) {
        // find first available flavour value
        for (var _fi = 0; _fi < product.variants.length; _fi++) {
          if (product.variants[_fi].available) {
            defaultFlavVal = product.variants[_fi]['option' + (flavIdx + 1)];
            break;
          }
        }
        if (!defaultFlavVal && product.variants.length) {
          defaultFlavVal = product.variants[0]['option' + (flavIdx + 1)];
        }
      }
      var firstVariant = pickSingleItemVariant(product, flavIdx, defaultFlavVal);
      _modalVariantId = firstVariant ? firstVariant.id : null;
  
      // ---- Images (filtered by variant alt-text convention) ----
      var galleryImages = getFilteredGalleryImages(product, firstVariant);
      var _openGalleryIdx = 0;
      if (firstVariant && firstVariant.featured_image && firstVariant.featured_image.src) {
        var _featSrc = firstVariant.featured_image.src.split('?')[0];
        for (var _gi = 0; _gi < galleryImages.length; _gi++) {
          var _gSrc = (typeof galleryImages[_gi] === 'object' ? galleryImages[_gi].src : galleryImages[_gi]) || '';
          if (_gSrc.split('?')[0] === _featSrc) { _openGalleryIdx = _gi; break; }
        }
      }
      populateGallery(galleryImages, _openGalleryIdx);
  
      // ---- Variants ----
      populateVariants(product, firstVariant);
  
      // ---- Price ----
      updateModalPrice(firstVariant);
  
      // ---- Discount tag ----
      updateModalDiscountTag();
  
      // ---- Description (from block settings) ----
      if (modalDescription) {
        var descData = (BB_PAGE_DATA.productDescriptions || {})[handle];
        var meta = (BB_PAGE_DATA.productMeta && BB_PAGE_DATA.productMeta[handle]) || {};
        var hasDesc = descData && descData.description;
        var hasRating = meta.looxRating && meta.looxRaters;
  
        if (hasDesc || hasRating) {
          var descHtml = '';
  
          // Rating stars (replaces old heading)
          if (hasRating) {
            descHtml += '<div class="bb-modal__desc-rating">'
              + '<div class="loox-rating loox-stars" data-id="' + meta.looxId + '" data-rating="' + meta.looxRating + '" data-raters="' + meta.looxRaters + '"></div>'
              + '</div>';
          }
  
          if (hasDesc) {
            // Convert <p> blocks that contain ✦ bullets into <ul><li> lists.
            var _desc = descData.description
              .replace(/✦\s*/g, '\x00')
              .replace(/<p>([\s\S]*?)<\/p>/g, function(match, inner) {
                if (inner.indexOf('\x00') === -1) return match;
                var lines = inner.split(/\x00|<br\s*\/?>/i)
                  .map(function(l) { return l.trim(); })
                  .filter(function(l) { return l.length > 0; });
                return '<ul>' + lines.map(function(l) { return '<li>' + l + '</li>'; }).join('') + '</ul>';
              });
            descHtml += '<div class="bb-modal__desc-body">' + _desc + '</div>';
          }
          modalDescription.innerHTML = descHtml;
          modalDescription.style.display = '';
  
          // Re-trigger Loox to render the stars inside the modal
          if (hasRating && window.loox) {
            try { window.loox.init(); } catch(_e) {}
          }
        } else {
          modalDescription.innerHTML = '';
          modalDescription.style.display = 'none';
        }
      }
  
      // ---- Show ----
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  
    function closeModal() {
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (_slideObserver) { _slideObserver.disconnect(); _slideObserver = null; }
      _modalProduct = null;
      _modalVariantId = null;
      _modalHandle = null;
    }
  
    /* Gallery — scroll-snap based dual carousel */
    var _activeSlideIdx = 0;
    var _slideObserver = null;

    function _getSlideId(idx) {
      var handle = _modalHandle || 'modal';
      return 'bbSlide-' + handle + '-' + idx;
    }

    function isMobileModalCarousel() {
      return true; // gallery always uses horizontal layout
    }

    /* ---- Gallery alt-text filtering (mirrors PDP logic) ----
       If any image in the product has alt containing "Gallery", we only show
       images whose alt matches "{VariantOptionValue} Gallery" plus untagged images.
       If no images use the convention, all images are shown. */
    function productHasGalleryConvention(product) {
      var media = product.media || [];
      for (var i = 0; i < media.length; i++) {
        if (media[i].media_type !== 'image') continue;
        var alt = (media[i].alt || '').toLowerCase();
        if (alt.indexOf('gallery') !== -1) return true;
      }
      return false;
    }

    function getFilteredGalleryImages(product, variant) {
      var media = product.media || [];
      var images = [];
      for (var i = 0; i < media.length; i++) {
        if (media[i].media_type !== 'image') continue;
        images.push(media[i]);
      }

      // Fallback: if no media entries, use product.images (URL strings)
      if (images.length === 0 && product.images && product.images.length) {
        return product.images;
      }

      if (!productHasGalleryConvention(product) || !variant) {
        return images;
      }

      // Build expected alt from the variant's flavour option value
      var flavIdx = flavourOptionIndex(product);
      var flavourVal = '';
      if (flavIdx >= 0) {
        flavourVal = variant['option' + (flavIdx + 1)] || '';
      } else {
        flavourVal = variant.title || '';
      }
      var expectedAlt = flavourVal + ' Gallery';

      var filtered = [];
      for (var j = 0; j < images.length; j++) {
        var alt = images[j].alt || '';
        var altLower = alt.toLowerCase();

        // Untagged images (no "gallery" in alt) — always keep
        if (altLower.indexOf('gallery') === -1) {
          filtered.push(images[j]);
          continue;
        }

        // Pack-tagged images — always keep (managed elsewhere)
        if (altLower.indexOf('single ') !== -1 || altLower.indexOf('-pack ') !== -1) {
          filtered.push(images[j]);
          continue;
        }

        // Match: alt equals "{FlavourValue} Gallery" (case-insensitive)
        if (altLower === expectedAlt.toLowerCase()) {
          filtered.push(images[j]);
        }
      }

      return filtered.length > 0 ? filtered : images;
    }

    function populateGallery(images, activeIndex) {
      if (!modalMainCarousel || !modalThumbTrack) return;
  
      _activeSlideIdx = activeIndex || 0;
  
      // Tear down previous observer
      if (_slideObserver) { _slideObserver.disconnect(); _slideObserver = null; }
  
      if (!images || images.length === 0) {
        modalMainCarousel.innerHTML = '';
        modalThumbTrack.innerHTML = '';
        return;
      }

      // Clamp active index to available images
      if (_activeSlideIdx >= images.length) _activeSlideIdx = 0;
  
      // ---- Build main carousel slides ----
      var mainHTML = '';
      for (var i = 0; i < images.length; i++) {
        var src = images[i];
        if (typeof src === 'object') src = src.src || src;
        var bigSrc = src.split('?')[0] + '?width=600';
        var slideId = 'bbSlide-' + (_modalHandle || 'modal') + '-' + i;
        mainHTML += '<div class="bb-modal__main-slide" id="' + slideId + '" data-slide-idx="' + i + '">'
          + '<img src="' + bigSrc + '" alt="' + escapeAttr(_modalProduct ? _modalProduct.title : '') + ' - Image ' + (i + 1) + '" loading="lazy">'
          + '</div>';
      }
      modalMainCarousel.innerHTML = mainHTML;
  
      // ---- Build thumbnails ----
      var thumbsHTML = '';
      for (var t = 0; t < images.length; t++) {
        var tsrc = images[t];
        if (typeof tsrc === 'object') tsrc = tsrc.src || tsrc;
        var thumbSrc = tsrc.split('?')[0] + '?width=100';
        var cls = 'bb-modal__thumb-btn' + (t === _activeSlideIdx ? ' is-active' : '');
        thumbsHTML += '<button class="' + cls + '" type="button" data-thumb-idx="' + t + '">'
          + '<img src="' + thumbSrc + '" alt="Thumbnail ' + (t + 1) + '" loading="lazy">'
          + '</button>';
      }
      modalThumbTrack.innerHTML = thumbsHTML;
  
      // ---- Jump to initial slide instantly (no animation on open) ----
      requestAnimationFrame(function () {
        var target = document.getElementById(_getSlideId(_activeSlideIdx));
        if (target) {
          modalMainCarousel.style.scrollBehavior = 'auto';
          modalMainCarousel.scrollLeft = target.offsetLeft;
          requestAnimationFrame(function () {
            modalMainCarousel.style.scrollBehavior = '';
          });
        }
      });
  
      // ---- IntersectionObserver — sync thumb when user wheel-scrolls ----
      _slideObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= 0.5) {
            var idx = parseInt(entry.target.getAttribute('data-slide-idx'), 10);
            if (idx !== _activeSlideIdx) {
              _activeSlideIdx = idx;
              _syncActiveThumbs(idx);
            }
          }
        });
      }, { root: modalMainCarousel, threshold: 0.5 });
  
      var slides = modalMainCarousel.querySelectorAll('.bb-modal__main-slide');
      for (var s = 0; s < slides.length; s++) {
        _slideObserver.observe(slides[s]);
      }
    }
  
    /** Re-filter and repopulate gallery when variant changes */
    function updateGalleryForVariant(product, variant) {
      var galleryImages = getFilteredGalleryImages(product, variant);
      var startIdx = 0;
      if (variant && variant.featured_image && variant.featured_image.src) {
        var _featSrc = variant.featured_image.src.split('?')[0];
        for (var i = 0; i < galleryImages.length; i++) {
          var gSrc = (typeof galleryImages[i] === 'object' ? galleryImages[i].src : galleryImages[i]) || '';
          if (gSrc.split('?')[0] === _featSrc) { startIdx = i; break; }
        }
      }
      populateGallery(galleryImages, startIdx);
    }

    /** Sync active class on thumbs and scroll thumb strip */
    function _syncActiveThumbs(idx) {
      if (!modalThumbTrack) return;
      var allThumbs = modalThumbTrack.querySelectorAll('.bb-modal__thumb-btn');
      for (var j = 0; j < allThumbs.length; j++) {
        allThumbs[j].classList.toggle('is-active', j === idx);
      }
      var activeThumb = allThumbs[idx];
      if (activeThumb) {
        var thumbCarousel = document.getElementById('bbModalThumbCarousel');
        if (thumbCarousel) {
          var scrollLeft = activeThumb.offsetLeft - (thumbCarousel.offsetWidth / 2) + (activeThumb.offsetWidth / 2);
          thumbCarousel.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }
      }
    }
  
    /** Scroll the main carousel to a specific slide by ID — pixel-perfect, no math */
    function scrollMainToSlide(idx) {
      if (!modalMainCarousel) return;
      var target = document.getElementById(_getSlideId(idx));
      if (!target) return;
  
      _activeSlideIdx = idx;
      _syncActiveThumbs(idx);
  
      // scrollIntoView is scoped to the nearest scroll ancestor = modalMainCarousel
      // On mobile we snap horizontally; on desktop we keep vertical behavior.
      if (isMobileModalCarousel()) {
        target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  
    /* ---- Flavour-option helpers ---- */
    // Returns true if the option name is a flavour/flavor/taste option (not a size/pack/qty).
    // Only flavour options are shown in the modal — pack options are hidden entirely.
    function isFlavourOption(name) {
      return /flavou?r|sabor|taste|scent/i.test(name);
    }
  
    // Returns the index (0-based) of the first flavour option, or -1 if none.
    function flavourOptionIndex(product) {
      var opts = product.options || [];
      for (var i = 0; i < opts.length; i++) {
        var n = (typeof opts[i] === 'object' && opts[i] !== null) ? (opts[i].name || '') : String(opts[i]);
        if (isFlavourOption(n)) return i;
      }
      return -1;
    }
  
    // Given a flavour option index and value, return the variant with the LOWEST price
    // (= single item) that has that flavour value and is available. Falls back to any variant.
    // If flavVal is null/undefined, ignore flavour filtering and just pick cheapest available.
    function pickSingleItemVariant(product, flavOptIdx, flavVal) {
      var candidates = product.variants.filter(function (v) {
        if (flavOptIdx >= 0 && flavVal != null && v['option' + (flavOptIdx + 1)] !== flavVal) return false;
        return true;
      });
      if (!candidates.length) candidates = product.variants.slice();
      // Prefer available
      var available = candidates.filter(function (v) { return v.available; });
      var pool = available.length ? available : candidates;
      // Pick lowest price (= single item)
      pool.sort(function (a, b) { return a.price - b.price; });
      return pool[0] || null;
    }
  
    /* Variants */
    function populateVariants(product, selectedVariant) {
      if (!modalVariants) return;

      // Hide if single variant or "Default Title" only
      if (!product.variants || product.variants.length <= 1) {
        modalVariants.innerHTML = '';
        return;
      }
      if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
        modalVariants.innerHTML = '';
        return;
      }

      // Only render FLAVOUR options — pack/size/qty options are suppressed entirely.
      var optionNames = product.options || [];
      var html = '';
      for (var oi = 0; oi < optionNames.length; oi++) {
        var optObj = optionNames[oi];
        var optName = (typeof optObj === 'object' && optObj !== null) ? (optObj.name || '') : String(optObj);

        // Skip non-flavour options (pack size, qty, etc.)
        if (!isFlavourOption(optName)) continue;

        var selectedVal = selectedVariant ? selectedVariant['option' + (oi + 1)] : '';

        // Collect unique values for this option
        var uniqueValues = [];
        var seen = {};
        for (var vi = 0; vi < product.variants.length; vi++) {
          var val = product.variants[vi]['option' + (oi + 1)];
          if (seen[val]) continue;
          seen[val] = true;
          uniqueValues.push(val);
        }

        html += '<div class="bb-modal__option-group">';
        html += '<label class="bb-modal__variant-label">' + escapeHTML(optName) + ': <span>' + escapeHTML(selectedVal) + '</span></label>';

        if (uniqueValues.length > 5) {
          // Render as dropdown select
          html += '<div class="bb-modal__variant-select-wrap">';
          html += '<select class="bb-modal__variant-select" data-option-index="' + oi + '">';
          for (var si = 0; si < uniqueValues.length; si++) {
            var sVal = uniqueValues[si];
            var isSel = sVal === selectedVal;
            html += '<option value="' + escapeAttr(sVal) + '"' + (isSel ? ' selected' : '') + '>' + escapeHTML(sVal) + '</option>';
          }
          html += '</select>';
          html += '<svg class="bb-modal__variant-select-chevron" viewBox="0 0 16 16" fill="none"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          html += '</div>';
        } else {
          // Render as buttons
          html += '<div class="bb-modal__variant-options">';
          for (var bi = 0; bi < uniqueValues.length; bi++) {
            var bVal = uniqueValues[bi];
            var isSelected = bVal === selectedVal;
            html += '<button class="bb-modal__variant-btn' + (isSelected ? ' is-selected' : '') + '" type="button" '
              + 'data-option-index="' + oi + '" data-option-value="' + escapeAttr(bVal) + '">'
              + escapeHTML(bVal) + '</button>';
          }
          html += '</div>';
        }
        html += '</div>';
      }
      modalVariants.innerHTML = html;
    }
  
    /* Price */
    function updateModalPrice(variant) {
      if (!variant) return;
      if (modalPrice) modalPrice.textContent = formatMoney(variant.price);
      if (modalComparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          modalComparePrice.textContent = formatMoney(variant.compare_at_price);
          modalComparePrice.style.display = '';
        } else {
          modalComparePrice.textContent = '';
          modalComparePrice.style.display = 'none';
        }
      }
    }
  
    /* Discount tag */
    function updateModalDiscountTag() {
      if (!modalDiscountTag) return;
      var tier = tiers.length > 0 ? tiers[tiers.length - 1] : null;
      if (tier) {
        modalDiscountTag.innerHTML = '<svg viewBox="0 0 13 16" fill="none"><path d="M10.2 0.17C10.42-0.06 10.77-0.06 10.98 0.17L11.73 0.96C12.59 1.86 12.59 3.32 11.73 4.22L11.2 4.78L12.02 7.92C12.23 8.72 12.01 9.57 11.45 10.16L6.78 15.07C5.92 15.97 4.54 15.97 3.68 15.07L0.64 11.88C-0.21 10.98-0.21 9.52 0.64 8.62L5.32 3.7C5.87 3.11 6.68 2.89 7.44 3.11L10.43 3.96L10.96 3.41C11.39 2.96 11.39 2.23 10.96 1.78L10.2 0.98C9.99 0.76 9.99 0.39 10.2 0.17Z" fill="currentColor"/></svg>'
          + '<span>' + tier.qty + '+ for ' + getDisplayPct(tier) + '% off</span>';
        modalDiscountTag.classList.add('is-visible');
      } else {
        modalDiscountTag.classList.remove('is-visible');
      }
    }
  
    /* Resolve variant from selected options */
    function resolveVariant(product, selectedOptions) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var oi = 0; oi < selectedOptions.length; oi++) {
          if (v['option' + (oi + 1)] !== selectedOptions[oi]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }
  
    /* Modal event delegation */
    if (modal) {
      // Mouse-wheel on the main carousel — advance/retreat slides
      if (modalMainCarousel) {
        var _wheelTimer = null;
        modalMainCarousel.addEventListener('wheel', function (e) {
          e.preventDefault(); // stop page scroll
          clearTimeout(_wheelTimer);
          _wheelTimer = setTimeout(function () {
            if (!_modalProduct) return;
            var slides = modalMainCarousel.querySelectorAll('.bb-modal__main-slide');
            var total = slides.length;
            if (total < 2) return;
            var next = _activeSlideIdx + (e.deltaY > 0 ? 1 : -1);
            if (next < 0) next = 0;
            if (next >= total) next = total - 1;
            if (next !== _activeSlideIdx) scrollMainToSlide(next);
          }, 50);
        }, { passive: false });
      }
  
      // Close
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-bb-modal-close]')) {
          e.preventDefault();
          closeModal();
          return;
        }
  
        // Thumbnail click — smooth scroll main carousel to that slide
        var thumbBtn = e.target.closest('[data-thumb-idx]');
        if (thumbBtn && _modalProduct) {
          var idx = parseInt(thumbBtn.getAttribute('data-thumb-idx'), 10);
          scrollMainToSlide(idx);
          return;
        }
  
        // Variant option click (flavour buttons only)
        var optBtn = e.target.closest('[data-option-value]');
        if (optBtn && _modalProduct) {
          var optIdx = parseInt(optBtn.getAttribute('data-option-index'), 10);
          var optVal = optBtn.getAttribute('data-option-value');

          var variant = pickSingleItemVariant(_modalProduct, optIdx, optVal);
          if (variant) {
            _modalVariantId = variant.id;
            populateVariants(_modalProduct, variant);
            updateModalPrice(variant);
            updateGalleryForVariant(_modalProduct, variant);
          }
          return;
        }
      });
  
      // Variant dropdown select change
      modal.addEventListener('change', function (e) {
        var select = e.target.closest('.bb-modal__variant-select');
        if (select && _modalProduct) {
          var optIdx = parseInt(select.getAttribute('data-option-index'), 10);
          var optVal = select.value;

          var variant = pickSingleItemVariant(_modalProduct, optIdx, optVal);
          if (variant) {
            _modalVariantId = variant.id;
            populateVariants(_modalProduct, variant);
            updateModalPrice(variant);
            updateGalleryForVariant(_modalProduct, variant);
          }
        }
      });

      // ESC key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
          closeModal();
        }
      });
    }
  
    /* Add to bundle from modal */
    if (modalAddBtn) {
      modalAddBtn.addEventListener('click', function () {
        if (!_modalVariantId || !_modalHandle) return;
        if (selectedItems.length >= maxSlots) return;
  
        var card = grid.querySelector('.bb-card[data-product-handle="' + _modalHandle + '"]');
        if (card) {
          addToBundle(String(_modalVariantId), card);
        }
        closeModal();
      });
    }
  
    /* ===========================================================
       EVENT LISTENERS
       =========================================================== */
    grid.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-action="add-direct"]');
      if (addBtn) {
        e.preventDefault();
        var card = addBtn.closest('.bb-card');
        if (card) addToBundle(addBtn.getAttribute('data-variant-id'), card);
        return;
      }
      var trigger = e.target.closest('[data-variant-trigger]');
      if (trigger) {
        e.preventDefault();
        var panel = trigger.closest('[data-variant-panel]');
        if (panel) panel.classList.toggle('is-open');
        return;
      }
      var readMore = e.target.closest('[data-action="read-more"]');
      if (readMore) {
        e.preventDefault();
        var handle = readMore.closest('.bb-card').getAttribute('data-product-handle');
        if (handle) openModal(handle);
        return;
      }
      // Click on card image → open modal (but not if clicking the add button or variant panel)
      var imgWrap = e.target.closest('.bb-card__img-wrap');
      if (imgWrap && !e.target.closest('[data-action]') && !e.target.closest('[data-variant-panel]')) {
        e.preventDefault();
        var handle = imgWrap.closest('.bb-card').getAttribute('data-product-handle');
        if (handle) openModal(handle);
      }
    });
  
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-variant-panel]')) {
        grid.querySelectorAll('.bb-card__variant-panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
      }
    });
  
    if (slotsContainer) {
      slotsContainer.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-action="remove-slot"]');
        if (!btn) return;
        var filledSlots = Array.from(slotsContainer.querySelectorAll('.bb-aside__slot.is-filled'));
        var idx = filledSlots.indexOf(btn.closest('.bb-aside__slot'));
        if (idx !== -1) removeFromBundle(idx);
      });
    }
  
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
        addBundleToCart({ sourceButton: addToCartBtn });
      });
    }
    if (mobileAddToCartBtn) {
      mobileAddToCartBtn.addEventListener('click', function () {
        addBundleToCart({ sourceButton: mobileAddToCartBtn });
      });
    }
    if (mobileOneTimeBtn) {
      mobileOneTimeBtn.addEventListener('click', function () {
        addBundleToCart({ forceOneTime: true, sourceButton: mobileOneTimeBtn });
      });
    }
  
    /* ===========================================================
       SUBSCRIBE & SAVE — toggle collapse on checkbox change
       =========================================================== */
    var subscribeCheckbox = document.getElementById('bbSubscribeCheckbox');
    var subscribeInner = document.querySelector('.bb-subscribe__inner');
  
    if (subscribeCheckbox && subscribeInner) {
      // Always keep subscription selected
      subscribeCheckbox.checked = true;
      subscribeInner.classList.remove('is-collapsed');

      if (oneTimePurchaseBtn) {
        oneTimePurchaseBtn.addEventListener('click', function () {
          addBundleToCart({ forceOneTime: true, sourceButton: oneTimePurchaseBtn });
        });
      }
  
      subscribeCheckbox.addEventListener('change', function () {
        // Prevent unchecked state from any user/script interaction.
        if (!subscribeCheckbox.checked) subscribeCheckbox.checked = true;
        subscribeInner.classList.remove('is-collapsed');
        updateUI();
      });
  
      // Clicking the header row also toggles the checkbox
      var subscribeHeader = document.querySelector('.bb-subscribe__header');
      if (subscribeHeader) {
        subscribeHeader.addEventListener('click', function (e) {
          if (e.target.closest('.bb-subscribe__label-wrap')) return; // let label handle it natively
          subscribeCheckbox.checked = !subscribeCheckbox.checked;
          subscribeCheckbox.dispatchEvent(new Event('change'));
        });
      }
    }
  
    /* ===========================================================
       MOBILE STICKY BAR — show when ATC button scrolls out of view
       Only active on mobile (< 1024px). Uses IntersectionObserver.
       =========================================================== */
    var mobileBar = document.getElementById('bbMobileBar');
    var quizEmbed = document.querySelector('.product-quiz');

    if (mobileBar && addToCartBtn && 'IntersectionObserver' in window && !quizEmbed) {
      var atcObserver = new IntersectionObserver(
        function (entries) {
          // Only act on mobile viewports
          if (window.innerWidth >= 1024) {
            mobileBar.classList.remove('is-visible');
            return;
          }
          // Button is NOT visible → show sticky bar
          if (!entries[0].isIntersecting) {
            mobileBar.classList.add('is-visible');
          } else {
            mobileBar.classList.remove('is-visible');
          }
        },
        { threshold: 0 }
      );
      atcObserver.observe(addToCartBtn);
  
      // Also hide bar when viewport resizes to desktop
      window.addEventListener('resize', function () {
        if (window.innerWidth >= 1024) {
          mobileBar.classList.remove('is-visible');
        }
      });
    }
  
    /* ===========================================================
       INIT — load all products then render UI
       =========================================================== */
    Promise.all(handles.map(loadProduct)).then(function () {
      updateUI();
    });
  
  })();
  